module.exports = __webpack_public_path__ + "static/media/44_B.96570f9c.png";